<template>
  <mi-dialog
    :model-value="deleteModal"
    :custom-design-dialog="true"
    class="delete-dialog"
    no-backdrop-dismiss
  >
    <div>
      <div class="delete-header-wrapper q-mb-lg">
        <h3 class="q-mt-none q-mb-lg delete-header"> Are you sure you want to delete this List? </h3>
        <div class="delete-close-icon">
          <mi-btn
            icon="close"
            icon-type
            icon-size="21px"
            fab
            flat
            @click="handleCloseDeleteModal"
          ></mi-btn>
        </div>
      </div>

      <!-- Subtitle -->
      <p class="q-mb-xl">
        This action cannot be undone.
      </p>
    </div>

    <div class="delete-wrapper">
      <!-- Cancel button -->
      <mi-btn flat @click="handleCloseDeleteModal"> Cancel </mi-btn>

      <!-- Submit button -->
      <mi-btn color="accent" @click="handleDeleteListConfiguration(rowId)"> Delete </mi-btn>
    </div>
  </mi-dialog>
</template>

<script>
  export default {
    name: 'DeleteConfirmationModal',
    props: {
      rowId: {
        type: String,
        required: false,
        default: ''
      },
      deleteModal: {
        type: Boolean,
        default: false
      },
      restorePoint: {
        type: Object,
        default: () => {}
      },
      handleDeleteListConfiguration: {
        type: Function,
        default: () => {}
      },
      handleCloseDeleteModal: {
        type: Function,
        default: () => {}
      }
    }
  }
</script>

<style>
  .delete-dialog {
    .q-dialog__inner > .mi-card {
      width: 683px;
      max-width: 683px;
      min-width: 580px;
      height: 210px;
      padding: 16px 24px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  @media (max-width: $mi-responsive-large-width) {
    .delete-dialog {
      .q-dialog__inner > .mi-card {
        width: 683px;
        max-width: 683px;
      }
    }
  }

  @media (max-width: $mi-responsive-medium-width) {
    .delete-dialog {
      .q-dialog__inner > .mi-card {
        width: 477px;
        max-width: 477px;
      }
    }
  }

  .delete-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 16px;
  }

  .delete-header {
    font-size: 28px;
    line-height: 42px;
    font-weight: 700;
    margin: 0;
  }

  .delete-close-icon {
    display: flex;
    justify-content: flex-end;
  }

  .delete-header-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
</style>
